/**
 * Fond du corps de l'e-mail, celui sur lequel les sections se posent. Le gris très pâle du gabarit
 * du serveur : c'est ce que le destinataire voit d'un e-mail dont personne n'a réglé le fond.
 */
export const EMAIL_DEFAULT_BODY_COLOR = '#ebeef4';
